if (!window.Eurus.loadedScript.has('estimate-shipping-rate.js')) {
  window.Eurus.loadedScript.add('estimate-shipping-rate.js');
  const registerShippingEstimator = () => {
    Alpine.data('xEstimateShipping', (el, single, multiple, noRates) => ({
      countryEl: el.querySelector('.country-select'),
      provinceEl: el.querySelector('.province-select'),
      provinceContainer: el.querySelector('.province-container'),
      zip: el.querySelector('.zip-input'),
      rates: el.querySelector('.rates'),
      errors: el.querySelector('.errors'),
      loadingShipping: false,
      rates_heading: '',
      rates_text: '',
      errors_message: '',
      subtotal: null,
      loaded: false,
      basketVersion: 0,
      basketChanged: null,
      copy: JSON.parse(el.dataset.shippingCopy || '{}'),
      thresholds: JSON.parse(el.dataset.shippingThresholds || '{}'),
      load() {
        if (this.loaded) return;
        this.loaded = true;
        this.setSelectedOption(this.countryEl, 'Canada');
        this.handleCountryChange();
        this.setSelectedOption(this.provinceEl, this.provinceEl.dataset.default);
        [this.countryEl, this.provinceEl, this.zip].forEach(input => {
          input.addEventListener('change', () => this.clearResult());
        });
        this.countryEl.addEventListener('change', () => this.handleCountryChange());
        this.zip.addEventListener('input', () => this.clearResult());
        this.basketChanged = () => {
          this.basketVersion += 1;
          this.clearResult();
        };
        document.addEventListener('eurus:cart:items-changed', this.basketChanged);
        document.addEventListener('eurus:product:added', this.basketChanged);
      },
      destroy() {
        document.removeEventListener('eurus:cart:items-changed', this.basketChanged);
        document.removeEventListener('eurus:product:added', this.basketChanged);
      },
      clearResult() {
        this.rates.classList.add('hidden');
        this.errors.classList.add('hidden');
      },
      handleCountryChange() {
        const selected = this.countryEl.options[this.countryEl.selectedIndex];
        const provinces = JSON.parse(selected?.dataset.provinces || '[]');
        this.provinceEl.replaceChildren();
        provinces.forEach(([value, name]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = name;
          this.provinceEl.appendChild(option);
        });
        this.provinceContainer.hidden = provinces.length === 0;
      },
      setSelectedOption(select, value) {
        Array.from(select.options).forEach((option, index) => {
          if (option.value === value || option.textContent === value) select.selectedIndex = index;
        });
      },
      escape(value) {
        return String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
      },
      formatMoney(cents, currency = 'CAD') {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency }).format(cents / 100);
      },
      interpolate(template, values) {
        return Object.entries(values).reduce((text, [key, value]) => text.replaceAll('__' + key + '__', value), template || '');
      },
      async submit(event) {
        event?.preventDefault();
        if (this.loadingShipping) return;
        this.load();
        this.clearResult();
        this.subtotal = null;
        const params = new URLSearchParams({
          'shipping_address[zip]': this.zip.value.trim().toUpperCase(),
          'shipping_address[country]': this.countryEl.value,
          'shipping_address[province]': this.provinceEl.value
        });
        const destination = params.toString();
        const basketVersion = this.basketVersion;
        this.loadingShipping = true;
        try {
          const [response, cartResponse] = await Promise.all([
            fetch(Shopify.routes.root + 'cart/shipping_rates.json?' + params),
            fetch(Shopify.routes.root + 'cart.js', { cache: 'no-store' }).catch(() => null)
          ]);
          const data = await response.json();
          if (cartResponse?.ok) {
            const cart = await cartResponse.json();
            if (cart.currency === 'CAD') this.subtotal = Number(cart.total_price);
          }
          const current = new URLSearchParams({
            'shipping_address[zip]': this.zip.value.trim().toUpperCase(),
            'shipping_address[country]': this.countryEl.value,
            'shipping_address[province]': this.provinceEl.value
          });
          if (current.toString() !== destination || basketVersion !== this.basketVersion) return;
          if (response.ok) this.showRates(data);
          else this.showErrors(data);
        } catch {
          this.showErrors({ shipping: this.copy.error });
        } finally {
          this.loadingShipping = false;
        }
      },
      showRates(data) {
        const heading = this.rates.querySelector('.rates-heading');
        const rates = data.shipping_rates || [];
        this.rates_heading = this.copy.heading || single;
        if (rates.length) {
          const lines = rates.map(rate => '<li>' + this.escape(rate.name) + ': <strong>' + this.escape(this.formatMoney(Math.round(Number(rate.price) * 100), rate.currency || 'CAD')) + '</strong></li>');
          const urgent = rates.some(rate => /urgent|express|overnight/i.test(rate.name));
          const hasStandard = rates.some(rate => /standard/i.test(rate.name));
          const postcode = this.zip.value.replace(/\s/g, '').toUpperCase();
          const region = this.provinceEl.options[this.provinceEl.selectedIndex]?.textContent || this.provinceEl.value;
          const toronto = this.countryEl.value === 'Canada' && /^M\d[A-Z]\d[A-Z]\d$/.test(postcode);
          const threshold = toronto ? this.thresholds.toronto : this.thresholds[region];
          const zeroRate = rates.some(rate => Number(rate.price) === 0 && !/pickup|pick.up/i.test(rate.name));
          if (this.copy.heading) {
          if (zeroRate) {
            lines.push('<li>' + this.escape(this.copy.freeAvailable) + '</li>');
          } else if (toronto && threshold) {
            lines.push('<li>' + this.escape(this.interpolate(this.copy.toronto, { threshold: this.formatMoney(threshold) })) + '</li>');
          } else if (threshold && hasStandard && !urgent) {
            const text = this.interpolate(this.copy.threshold, { region, threshold: this.formatMoney(threshold) });
            const remaining = this.subtotal !== null && this.subtotal < threshold
              ? ' ' + this.interpolate(this.copy.remaining, { amount: this.formatMoney(threshold - this.subtotal) }) : '';
            lines.push('<li>' + this.escape(text + remaining) + '</li>');
          } else {
            lines.push('<li>' + this.escape(urgent ? this.copy.urgent : this.copy.eligibility) + '</li>');
          }
          }
          heading.classList.remove('hidden');
          this.rates_text = '<ul style="list-style:disc;padding-left:1.2em;display:grid;gap:.45em">' + lines.join('') + '</ul>' + (this.copy.perishable ? '<p style="font-size:.875em;line-height:1.5;margin-top:.75em">' + this.escape(this.copy.perishable) + '</p>' : '');
        } else {
          heading.classList.add('hidden');
          this.rates_text = '<p>' + this.escape(noRates) + '</p>';
        }
        this.rates.classList.remove('hidden');
      },
      showErrors(data) {
        this.errors_message = '<ul>' + Object.values(data).map(value => '<li>' + this.escape(Array.isArray(value) ? value.join(', ') : value) + '</li>').join('') + '</ul>';
        this.errors.classList.remove('hidden');
      }
    }));
    if (!Alpine.store('xPopupShipping')) Alpine.store('xPopupShipping', { open: false });
  };
  if (window.Alpine) registerShippingEstimator();
  else document.addEventListener('alpine:init', registerShippingEstimator, { once: true });
}
